<template>
    <Popup :show="show" v-on:closeEvent="close">
        <div class="popup-container">
            <div class="circle"></div>
            <h2>{{$t("lesson.LBL_TECH_POPUP_SUCCESS_HEADER")}}</h2>
            <span class="text">{{$t("lesson.LBL_TECH_POPUP_SUCCESS_DESCRIPTION",{
                    date:dateConvert,
                    time:textTime
                })}}</span>
            <div class="buttons">
                <button class="button" @click="ok">
                    <span>{{$t("strings.BTN_CONTINUE")}}</span>
                </button>
            </div>
        </div>
    </Popup>
</template>

<script>
    import Popup from '../../../../../../components/Popup';
    import { MONTH_NAMES } from '../../../../../../utils/utils';

    export default {
        name: "WaitingTehBookingSuccessPopup",
        components: {
            Popup
        },
        props: {
            show: {
                type: Boolean,
                required: true
            },
            datetime: {
                type: String,
                required: true
            },
        },
        computed: {
            dateConvert() {
                let dateArr = this.datetime.split('-').map((item) => {
                    return parseInt(item)
                });
                return `${dateArr[2]} ${MONTH_NAMES[dateArr[1] - 1]} ${dateArr[0]}`
            },
            textTime() {
                if (this.datetime !== '') {
                    return this.datetime.split(' ')[1];
                }
                return '';
            },
        },
        methods: {
            close(){
                this.$emit('closeEvent', null);
            },
            ok() {
                this.$emit('closeEvent', null);
            }
        },
    }
</script>

<style scoped lang="scss">
    .circle {
        width: 4.8rem;
        height: 4.8rem;
        background-color: #05C46B;
        border-radius: 10rem;
        margin-bottom: 1.6rem;
    }
    .popup-container {
        width: 100%;
        align-self: auto;
        display: flex;
        flex-direction: column;
    }
    h2 {
        padding-bottom: 0.8rem;
    }
    .text {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: 0.1rem;
        color: rgba(11, 16, 34, 0.3);
    }
    .buttons {
        width: 100%;
        display: flex;
        margin-top: auto;
        .button {
        margin-left: auto;
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        }
    }
</style>
